export default __webpack_public_path__ + "static/media/pos-autoatendimento-numero-pedido.a63d9d62.jpg";